module.exports = __webpack_public_path__ + "static/media/Spotify.c2dcf6c0.jpg";